export enum MessageTypes {
    CacheRefreshed = "NewformaProjectsCacheRefreshed",
}
export class Messenger {
    on<T>(eventName: MessageTypes, callback: (data?: T) => void): () => void {
        const handler = (e: Event) => callback((e as CustomEvent).detail);
        document.addEventListener(eventName, handler);
        return () => document.removeEventListener(eventName, handler);
    }
    dispatch(eventName: MessageTypes, data?: any) {
        const event = new CustomEvent(eventName, {
            detail: data,
            bubbles: true,
            cancelable: true,
        });
        document.dispatchEvent(event);
    }
    remove(eventName: MessageTypes, callback: (data: any) => void) {
        document.removeEventListener(eventName, callback);
    }
}
